import { render, staticRenderFns } from "./MobileTourMeta.vue?vue&type=template&id=2c130b26&scoped=true&"
import script from "./MobileTourMeta.vue?vue&type=script&lang=js&"
export * from "./MobileTourMeta.vue?vue&type=script&lang=js&"
import style0 from "../MobilePage.scss?vue&type=style&index=0&id=2c130b26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c130b26",
  null
  
)

export default component.exports